import MainLayout from '@/shared/layout/main-layout';
import club from './club/club-module';
import team from './team/team-module';
import category from './category/category-module';
import player from './player/player-module';
import manager from './manager/manager-module';
import position from './position/position-module';
import coach from './coach/coach-module';
import teamManager from './team-manager/team-manager-module';
import document from './document/document-module';
import fieldManager from './field-manager/field-manager-module';
import referee from './referee/referee-module';
import tournament from './tournament/tournament-module';

export default [
  {
    path: '/entities',
    component: MainLayout,
    meta: { auth: true },
    children: [
      ...club.routes,
      ...team.routes,
      ...category.routes,
      ...player.routes,
      ...manager.routes,
      ...position.routes,
      ...coach.routes,
      ...teamManager.routes,
      ...document.routes,
      ...fieldManager.routes,
      ...referee.routes,
      ...tournament.routes
    ],
  },
];



// WEBPACK FOOTER //
// ./src/entities/entities-routes.js